import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import HideAppBar from "../../../widgets/header/HideAppBar";
import clsx from "clsx";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	Container, DialogActions,
	MenuItem,
	Tooltip, Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useHistory, useParams} from "react-router-dom";
import {getIntervistaById, updateIntervista} from "../../../../services/IntervistaServices";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import {AnagraficaContext, AppContext} from "../../../../App";
import {updateAnagrafica} from "../../../../services/AnagraficaServices";
import {useForm, FormProvider} from "react-hook-form";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import {resetAnagrafica, resetIntervista} from "../intervista/utils/ResetUtils";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {addDays, clean, diffDays, removeDays} from "../../../../utils/GenericUtils";
import {bigNoteRegisterNotRequired} from "../../../../utils/RegisterUtils";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {InfoLavorativeGrid} from "../intervista/content/InfoLavorativeGrid";
import {TitleUtils} from "../intervista/utils/TitleUtils";
import {SintomiGrid} from "../intervista/content/SintomiGrid";
import {RischioGrid} from "../intervista/content/RischioGrid";
import {getIntervistaApiData} from "../../../../services/utils/IntervistaApiData";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {tipologieQuarantena, tipoMonitortaggio} from "../../../../utils/arrays/Generics";
import {RadioGroupQuestion} from "../../../widgets/inputs/RadioGroupQuestion";
import GoogleMaps from "../../../widgets/inputs/GoogleMapsInput";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import IconButton from "@mui/material/IconButton";
import RemoveTwoToneIcon from "@mui/icons-material/RemoveTwoTone";
import AddTwoToneIcon from "@mui/icons-material/AddTwoTone";
import {useTheme} from "@mui/styles";
import {generateQuarantenaV2} from "../../../../services/QuaranteneServices";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {MedicoGrid} from "../intervista/content/MedicoGrid";


const IntervistaDetailPage = () => {
	const classes = BaseStyle();
	let {idIntervista} = useParams();
	let history = useHistory();
	let theme = useTheme();
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [isAnagraficaSet, setIsAnagraficaSet] = useState(false);
	const [isIntervistaSet, setIsIntervistaSet] = useState(false);
	const [submit, setSubmit] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const [submitIntervista, setSubmitIntervista] = useState(false);
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [value1, setValue1] = useState(null);
	const [inputValue1, setInputValue1] = useState("");
	const [open, setOpen] = useState(false);
	const methods = useForm({mode: "onChange", defaultValues: intervistaState.intervista})
	
	const onSubmit = useCallback((data) => {
		if (!intervistaState.loadingGetIntervista && intervistaState.errorGetIntervista === "") {
			setSubmitIntervista(true);
			updateIntervista({
				...intervistaState.intervista,
				...getIntervistaApiData({...data}),
				soggetto: {
					idSoggetto: intervistaState.intervista.soggetto.idSoggetto
				}
			}, intervistaDispatch)
		} else {
			setOpenSnackbar("error", "Ricarica la pagina in quanto c'è stato un errore ad ottenere l'intervista", appContext.dispatch);
		}
	}, [intervistaState.errorGetIntervista, intervistaState.intervista, intervistaState.loadingGetIntervista, appContext.dispatch, intervistaDispatch])
	
	const aggiornaAnagrafica = useCallback(async () => {
		let result = await methods.trigger([
			("soggetto.nome"),
			("soggetto.cognome"),
			("soggetto.codF"),
			("soggetto.tipoDocumento"),
			("soggetto.cell"),
			("soggetto.cell2"),
			("soggetto.email"),
			("soggetto.domASL"),
			("soggetto.resASL"),
			("soggetto.sesso"),
			("soggetto.dataNascita"),
			("soggetto.comuneNascita"),
		]);
		console.log("------1");
		console.log(result);
		if (result) {
			if (intervistaState.intervista.soggetto) {
				console.log("------2");
				console.log(result);
				let anagraficaPaziente = intervistaState.intervista.soggetto;
				let newData = methods.getValues()?.["soggetto"];
				setSubmit(true)
				updateAnagrafica(clean(getAnaGraficaApi({
					...anagraficaPaziente, ...newData
				})), intervistaState.intervista.soggetto?.idSoggetto, anagraficaContext.dispatch);
			}
			console.log("------3");
			console.log(result);
		} else {
			if (methods.errors["soggetto"]?.["indirizzoDomicilioId"]) {
				setOpenSnackbar("error", "Hei, controlla bene di aver inserito un domicilio corretto!", appContext.dispatch);
			} else if (methods.errors["soggetto"]?.["indirizzoResidenzaId"]) {
				setOpenSnackbar("error", "Hei, controlla bene di aver inserito una residenza corretta!", appContext.dispatch);
			} else {
				setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
			}
		}
	}, [appContext.dispatch, anagraficaContext.dispatch, methods, intervistaState.intervista.soggetto])
	
	const creaOrdinanza = useCallback(() => {
		if (!intervistaState.loadingGetIntervista && intervistaState.errorGetIntervista === "") {
			let data = methods.getValues();
			setSubmitQuarantena(true);
			let dataInizio = data["quarantena"]?.["dataInizio"]
			dataInizio?.setHours(0);
			dataInizio?.setMinutes(0);
			dataInizio?.setSeconds(0);
			dataInizio?.setMilliseconds(0);
			let dataFine = data["quarantena"]?.["dataFine"]
			dataFine?.setHours(0);
			dataFine?.setMinutes(0);
			dataFine?.setSeconds(0);
			dataFine?.setMilliseconds(0);
			generateQuarantenaV2({
				...data?.quarantena,
				dataInizio: dataInizio,
				dataFine: dataFine,
				idIntervista: idIntervista,
				score: 0,
				soggetto: {
					idSoggetto: intervistaState.intervista.soggetto.idSoggetto
				},
				tipoPaziente: "PAZ_ZERO",
				idFocolaio: intervistaState.intervista?.idFocolaio,
			}, quarantenaDispatch, true, "--", "PAZ_ZERO")
		} else {
			setOpenSnackbar("error", "Ricarica la pagina in quanto c'è stato un errore ad ottenere l'intervista", appContext.dispatch);
		}
	}, [idIntervista, methods, intervistaState.intervista, appContext.dispatch, intervistaState.loadingGetIntervista, intervistaState.errorGetIntervista])
	
	useEffect(() => {
		if (submitIntervista && !intervistaState.loadingUpdateIntervista && intervistaState.errorUpdateIntervista === "") {
			setSubmitIntervista(false);
			setOpenSnackbar("success", "Intervista aggiornata con successo", appContext.dispatch);
			history.push("/gestione/interviste")
		} else if (submitIntervista && !intervistaState.loadingUpdateIntervista && intervistaState.errorUpdateIntervista !== "") {
			setSubmitIntervista(false);
			setOpenSnackbar("error", intervistaState.errorUpdateIntervista, appContext.dispatch);
		}
	}, [submitIntervista, intervistaState.loadingUpdateIntervista, intervistaState.errorUpdateIntervista, appContext.dispatch, history]);
	
	useEffect(() => {
		getIntervistaById(idIntervista, intervistaDispatch)
	}, [idIntervista, intervistaDispatch])
	
	useEffect(() => {
		if (!isIntervistaSet && !intervistaState.loadingGetIntervista && intervistaState.errorGetIntervista === "") {
			methods.reset(resetIntervista(intervistaState.intervista))
			setIsIntervistaSet(true);
		}
	}, [intervistaState.loadingGetIntervista, intervistaState.errorGetIntervista, intervistaState.intervista, isIntervistaSet, methods])
	
	useEffect(() => {
		if (!isAnagraficaSet && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			methods.reset({
				...methods.getValues(),
				soggetto: resetAnagrafica(anagraficaContext.state.anagrafica)
			});
			setIsAnagraficaSet(true);
		}
	}, [methods, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica, isAnagraficaSet, anagraficaContext.state.anagrafica])
	
	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Anagrafica aggiornata con successo", appContext.dispatch)
		} else if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica.length > 1) {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch)
		}
	}, [anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica,
		appContext.dispatch, submit])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setSubmitQuarantena(false);
			
			if (quarantenaState.quarantena?.errors) {
				setOpenSnackbar("info", quarantenaState.quarantena.errors, appContext.dispatch);
				//history.push("/gestione/interviste");
			} else {
				setOpenSnackbar("success", "Ordinanza creata correttamente! Ora aggiorno l'intervista e ti faccio tornare indietro", appContext.dispatch);
				//history.push("/gestione/interviste");
			}
			
			if (!intervistaState.loadingGetIntervista && intervistaState.errorGetIntervista === "") {
				setSubmitIntervista(true);
				updateIntervista({
					...intervistaState.intervista,
					...getIntervistaApiData({...methods.getValues()}),
					soggetto: {
						idSoggetto: intervistaState.intervista.soggetto.idSoggetto
					}
				}, intervistaDispatch)
			}
			
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena,
		quarantenaState.quarantena, appContext.dispatch, history, methods, intervistaState.loadingGetIntervista, intervistaState.errorGetIntervista,
		intervistaState.intervista, intervistaDispatch])
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Intervista " + idIntervista} back={true}/>
				<Container maxWidth={"lg"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1}}>
									<FormProvider {...methods}>
										<Grid container spacing={3}>
											<TitleUtils title={"Anagrafica paziente"} num={0} bottomDiv={true}
											            subTitle={"Modifica se necessario l'anagrafica del paziente"} topDiv={false}/>
											{
												intervistaState.loadingGetIntervista ?
													<Grid item xs={12}><Skeleton height={500} style={{borderRadius: 24}}/></Grid> :
													intervistaState.errorGetIntervista !== "" ?
														<Grid item xs={12}><Alert severity="error" style={{borderRadius: 24, margin: 4}}>
															<AlertTitle><b>Hey!</b></AlertTitle>
															Ricarica la pagina, qualcosa è andato storto ...
														</Alert></Grid>
														:
														<React.Fragment>
															<AnagraficaCompleta anagrafica={intervistaState.intervista.soggetto}
															                    classes={classes} name={"soggetto."}
															                    intro={"false"} moreInfo={true}/>
															<Grid item xs={12} className={classes.flexRight}>
																<Tooltip
																	title={"Aggiorna anagrafica del paziente"}>
																	<Button size={"small"} className={classes.roundButton}
																	        style={{borderRadius: 24}}
																	        variant={"contained"} disableElevation
																	        onClick={aggiornaAnagrafica} disabled={submit} color={"secondary"}>
																		<b>Aggiorna anagrafica</b>
																	</Button>
																</Tooltip>
															</Grid>
															
															<TitleUtils title={"Medico di Medicina Generale"} num={1} bottomDiv={true}
															            subTitle={"Modifica se necessario il medico del paziente"}
															            topDiv={true}/>
															<MedicoGrid note={false}/>
															
															<TitleUtils title={"Informazioni di carattere socio-lavorative"} num={2} bottomDiv={true}
															            subTitle={"Modifica se necessario le informazioni socio-lavorative del paziente"}
															            topDiv={true}/>
															<InfoLavorativeGrid value={value1} setValue={setValue1} inputValue={inputValue1}
															                    setInputValue={setInputValue1}/>
															
															
															<TitleUtils title={"Sintomi e patologie"} num={3} bottomDiv={true}
															            subTitle={"Modifica se necessario i sintomi e le patologie del paziente"}
															            topDiv={true}/>
															<SintomiGrid/>
															
															<TitleUtils title={"Rischio e contagio"} num={4} bottomDiv={true}
															            subTitle={"Modifica se necessario i rischi e i contagi del paziente"}
															            topDiv={true}/>
															<RischioGrid/>
															
															<TitleUtils title={"Note complessive"} num={5} bottomDiv={true}
															            subTitle={"Modifica se necessario le note dell'intervista"}
															            topDiv={true}/>
															<Grid item xs={12}>
																<CustomMultiText
																	inputRef={methods.register(bigNoteRegisterNotRequired)}
																	label={"Note"}
																	autoFocus={false}
																	rows={10}
																	name={"note"}
																	error={methods.errors["note"]}
																/>
															</Grid>
														</React.Fragment>
											}
										</Grid>
									</FormProvider>
								</CardContent>
								<CardActions className={classes.flexRight}>
									{
										intervistaState.intervista.focolaioId !== null &&
										<Tooltip
											title={"Aggiungi un contatto all'intervista. Ti farà scegliere in seguito il tipo di contatto"}>
											<Button className={classes.roundButton} variant={"text"} size={"small"} disableElevation
											        style={{borderRadius: 24}}
											        disabled={submit}
											        onClick={() => history.push("/gestione/interviste/" + idIntervista + "/aggiungi/" + intervistaState.intervista.focolaioId + "/" + intervistaState.intervista.soggetto.idSoggetto)}>
												<b>Aggiungi un contatto</b>
											</Button>
										</Tooltip>
									}
									{
										intervistaState.intervista.focolaioId === null &&
										<Tooltip
											title={"Aggiungi una quarantena a quest'intervista"}>
											<Button className={classes.roundButton} variant={"text"} size={"small"} disableElevation
											        style={{borderRadius: 24}}
											        disabled={submit}
											        onClick={() => setOpen(true)}>
												<b>Aggiungi una quarantena/isolamento</b>
											</Button>
										</Tooltip>
									}
									<Tooltip title={"Aggiorna l'intervista del paziente"}>
										<Button className={classes.roundButton} variant={"contained"} size={"small"} disableElevation
										        style={{borderRadius: 24}}
										        color={"primary"} disabled={submit} onClick={methods.handleSubmit(onSubmit)}>
											<b>Aggiorna</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					</Grid>
				</Container>
				
				{
					open &&
					<SimpleDialog
						open={open}
						handleClose={() => setOpen(!open)}
						maxWidth={"lg"}
						title={"Aggiungi un'ordinanza"}
						content={
							<Grid container spacing={3}>
								<Grid item xs={12} sm={6}>
									<CustomSelect
										label={"Quarantena o isolamento?"}
										control={methods.control}
										defaultValue={tipologieQuarantena[0]}
										autoFocus={true}
										rules={{required: true}}
										name={"quarantena.tipo"}
										error={methods.errors["quarantena"]?.["tipo"]}
									>
										{tipologieQuarantena.map((val, key) => {
											return (
												<MenuItem value={val} key={key}>
													{val}
												</MenuItem>
											);
										})}
									</CustomSelect>
								</Grid>
								<Grid item xs={12} sm={6}>
									<CustomSelect
										label={"Tipo di monitoraggio"}
										control={methods.control}
										defaultValue={tipoMonitortaggio[0]}
										autoFocus={false}
										rules={{required: true}}
										name={"quarantena.tipoMonitoraggio"}
										error={methods.errors["quarantena"]?.["tipoMonitoraggio"]}
									>
										{tipoMonitortaggio.map((val, key) => {
											return (
												<MenuItem value={val} key={key}>
													{val}
												</MenuItem>
											);
										})}
									</CustomSelect>
								</Grid>
								<Grid item xs={12}>
									<RadioGroupQuestion
										question={"Vuoi protocollare questo/a Isolamento/Quarantena?"}
										control={methods.control}
										defaultValue={"true"}
										rules={{required: true}}
										name={"quarantena.protocollo"}
										error={methods.errors["quarantena"]?.["protocollo"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<GoogleMaps value={value1} setValue={setValue1} inputValue={inputValue1}
									            setInputValue={setInputValue1}
									            label={"Indirizzo associato alla quarantena *"}/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={methods.register(bigNoteRegisterNotRequired)}
										label={"Note aggiuntive"}
										autofocus={false}
										name={"quarantena.note"}
										error={methods.errors["quarantena"]?.["note"]}
									/>
								</Grid>
								<Grid item xs={12} sm={5}>
									<CustomDateInput
										label={"Data inizio"}
										control={methods.control}
										defaultValue={new Date()}
										rules={{required: true}}
										name={"quarantena.dataInizio"}
										error={methods.errors["quarantena"]?.["dataInizio"]}
									/>
								</Grid>
								<Grid item xs={12} sm={5}>
									<CustomDateInput
										label={"Data fine"}
										control={methods.control}
										defaultValue={
											methods.watch("quarantena")?.["dataInizio"] ?
												addDays(new Date(methods.watch("quarantena")?.["dataInizio"]), 10) :
												addDays(new Date(), 10)}
										rules={{required: true}}
										name={"quarantena.dataFine"}
										error={methods.errors["quarantena"]?.["dataFine"]}
									/>
								</Grid>
								<Grid item xs={12} sm={2}>
									<IconButton
                                        onClick={() => {
                                            let prevFineDate = methods.watch("quarantena")?.["dataFine"]
                                            let newFineDate = removeDays(prevFineDate, 1)
                                            methods.setValue("quarantena.dataFine", newFineDate);
                                        }}
                                        size="large">
										<RemoveTwoToneIcon/>
									</IconButton>
									<IconButton
                                        onClick={() => {
                                            let prevFineDate = methods.watch("quarantena")?.["dataFine"]
                                            let newFineDate = addDays(prevFineDate, 1)
                                            methods.setValue("quarantena.dataFine", newFineDate);
                                        }}
                                        size="large">
										<AddTwoToneIcon/>
									</IconButton>
								</Grid>
								<Grid item xs={12} style={{display: "flex"}}>
									<Typography>Durata
										{"  " + methods.watch("quarantena")?.["tipo"] + ":  "}
										<b style={{color: theme.palette.primary.main, fontSize: 28}}>
											{diffDays(methods.watch("quarantena")?.["dataInizio"], methods.watch("quarantena")?.["dataFine"]) + " "}
											gg</b>
									</Typography>
								</Grid>
							</Grid>
						}
						actions={
							<DialogActions>
								<Button size={"small"} variant={"contained"} color={"primary"} disableElevation
								        className={classes.roundButton} style={{borderRadius: 24}} onClick={creaOrdinanza}>
									<b>Crea ordinanza</b>
								</Button>
							</DialogActions>
						}
					/>
				}
			
			</main>
        </React.Fragment>
    );
}

export default React.memo(IntervistaDetailPage);
